import styled from '@emotion/styled';
import { MenuItemsNavigation } from 'src/components/Menu/Menu.style';

export const MenuItemsNavigationTrading = styled(MenuItemsNavigation, { label: 'MenuItemsNavigationTrading' })`
    flex: 0 0 248px;
    width: 248px;
`;
